import Colors from "../../../../Constants/Colors";
import "./../AstrologerProfile.css";
import "./../../../../Constants/CommonStyle.css";
import Icons from "../../../../Constants/Icons";
import moment from "moment";
import Rating from "react-rating";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
import { apiGetAstrologerReview } from "../../../../Core/Apicall";
import { useNavigate } from "react-router-dom";
function ReviewAstrologer({ astrologerId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reviewContainerRef = useRef(null);
  const [pageComments, setPageComments] = useState(0);
  const [totalReview, setTotalReview] = useState(0);
  const [totalOneStarRatingCount, setTotalOneStarRatingCount] = useState(0);
  const [totalTwoStarRatingCount, setTotalTwoStarRatingCount] = useState(0);
  const [totalThreeStarRatingCount, setTotalThreeStarRatingCount] = useState(0);
  const [totalFourStarRatingCount, setTotalFourStarRatingCount] = useState(0);
  const [totalFiveStarRatingCount, setTotalFiveStarRatingCount] = useState(0);
  const [averageReview, setAverageReview] = useState(0);
  const [totalPaginationCount, setTotalPaginationCount] = useState(0);
  const [ratingReview, setRatingReview] = useState([]);

  useEffect(() => {
    onApiCallProductReview();
  }, [pageComments]);

  const onApiCallProductReview = () => {
    let param = {
      offset: 30 * pageComments,
      limit: 30,
    };
    let data = {
      astrologerId: astrologerId,
    };
    dispatch(setLoadingTrue());
    apiGetAstrologerReview(param, data)
      .then((response) => {
        setTotalPaginationCount(Math.ceil(response.totalRatingCount / 30));
        setAverageReview(response?.averageRating);
        setTotalReview(response?.totalRatingCount);
        setTotalOneStarRatingCount(response?.totalOneStarRatingCount);
        setTotalTwoStarRatingCount(response?.totalTwoStarRatingCount);
        setTotalThreeStarRatingCount(response?.totalThreeStarRatingCount);
        setTotalFourStarRatingCount(response?.totalFourStarRatingCount);
        setTotalFiveStarRatingCount(response?.totalFiveStarRatingCount);
        setRatingReview((prevData) => [...prevData, ...response?.reviews]);
        dispatch(setLoadingFalse());
      })
      .catch((err) => {
        dispatch(setLoadingFalse());
      });
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      reviewContainerRef?.current;
    if (scrollTop + clientHeight + 1 > scrollHeight) {
      if (totalPaginationCount > pageComments + 1) {
        setPageComments(pageComments + 1);
      }
    }
  };

  const onClickUserProfileNav = (item) => {
    navigate("/UserProfile", {
      state: {
        userId: item.UserId,
        userShortId: item?.userShortId ?? item.UserId,
      },
    });
  };

  const renderEmptyView = () => {
    return (
      <div
        style={{
          alignItems: "center",
          display: "flex",
          flex: 1,
          marginTop: "40px",
          alignSelf: "stretch",
          color: "#FFF",
          fontWeight: 800,
          justifyContent: "center",
        }}
      >
        No reviews available yet
      </div>
    );
  };
  return (
    <div
      style={{
        padding: 20,
        alignSelf: "stretch",
        backgroundColor: Colors.darkBlack,
      }}
    >
      {totalReview == 0 ? (
        renderEmptyView()
      ) : (
        <div style={{ display: "flex", gap: "1rem" }}>
          <div style={{ flex: 1 }}>
            <div
              style={{ marginBottom: "1rem" }}
              className="Main-Title-Product"
            >
              Overall Ratings
            </div>
            <div
              style={{
                background: "#25252D",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "16px",
              }}
            >
              <div
                style={{
                  marginTop: "1rem",
                  marginBottom: "0.3rem",
                  fontSize: "2rem",
                }}
                className="Main-Title-Product"
              >
                {averageReview}
              </div>
              <div style={{}}>
                <Rating
                  readonly={true}
                  initialRating={averageReview}
                  emptySymbol={
                    <span style={{ padding: 5 }}>
                      <FontAwesomeIcon
                        icon={regularStar}
                        style={{ color: Colors.orangeRating }}
                      />
                    </span>
                  }
                  fullSymbol={
                    <span style={{ padding: 5 }}>
                      <FontAwesomeIcon
                        icon={solidStar}
                        style={{ color: Colors.orangeRating }}
                      />
                    </span>
                  }
                />
              </div>
              <div
                style={{ marginTop: "0.5rem" }}
                className="Main-Title-Product"
              >
                based on {totalReview} reviews
              </div>
              <div className="div-justify-content-set">
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  5 Star
                  <FontAwesomeIcon
                    icon={solidStar}
                    style={{ color: Colors.orangeRating, paddingLeft: "5px" }}
                  />
                </div>

                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{
                      width: `${
                        (totalFiveStarRatingCount / totalReview) * 100
                      }%`,
                    }}
                  ></div>
                </div>
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  {totalFiveStarRatingCount}
                </div>
              </div>
              <div className="div-justify-content-set">
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  4 Star
                  <FontAwesomeIcon
                    icon={solidStar}
                    style={{ color: Colors.orangeRating, paddingLeft: "5px" }}
                  />
                </div>

                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{
                      width: `${
                        (totalFourStarRatingCount / totalReview) * 100
                      }%`,
                    }}
                  ></div>
                </div>
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  {totalFourStarRatingCount}
                </div>
              </div>
              <div className="div-justify-content-set">
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  3 Star
                  <FontAwesomeIcon
                    icon={solidStar}
                    style={{ color: Colors.orangeRating, paddingLeft: "5px" }}
                  />
                </div>

                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{
                      width: `${
                        (totalThreeStarRatingCount / totalReview) * 100
                      }%`,
                    }}
                  ></div>
                </div>
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  {totalThreeStarRatingCount}
                </div>
              </div>
              <div className="div-justify-content-set">
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  2 Star
                  <FontAwesomeIcon
                    icon={solidStar}
                    style={{ color: Colors.orangeRating, paddingLeft: "5px" }}
                  />
                </div>

                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{
                      width: `${
                        (totalTwoStarRatingCount / totalReview) * 100
                      }%`,
                    }}
                  ></div>
                </div>
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  {totalTwoStarRatingCount}
                </div>
              </div>
              <div className="div-justify-content-set">
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  1 Star
                  <FontAwesomeIcon
                    icon={solidStar}
                    style={{ color: Colors.orangeRating, paddingLeft: "5px" }}
                  />
                </div>

                <div className="progress-bar">
                  <div
                    className="progress"
                    style={{
                      width: `${
                        (totalOneStarRatingCount / totalReview) * 100
                      }%`,
                    }}
                  ></div>
                </div>
                <div
                  style={{ fontSize: "0.8rem", fontWeight: 600 }}
                  className="Main-Title-Product"
                >
                  {totalOneStarRatingCount}
                </div>
              </div>
            </div>
          </div>

          <div style={{ flex: 3 }}>
            <div
              style={{
                display: "flex",
                marginBottom: "1rem",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{}} className="Main-Title-Product">
                Reviews
              </div>
              <div></div>
            </div>

            <div
              style={{
                borderRadius: "13px",
                border: "1px solid #FFFFFF1A",
              }}
            >
              <div
                style={{
                  margin: "0rem 0rem 0rem 0rem",
                  flex: "1",
                  gap: "0.5rem",
                  overflowY: "scroll",
                  maxHeight: "60vh",
                }}
                ref={reviewContainerRef}
                onScroll={handleScroll}
                className="scrollable-container"
              >
                {ratingReview?.map((review, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          background: "transparent",
                          borderRadius: "7px",
                          padding: "10px",
                        }}
                      >
                        <div style={{}}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "0.5rem",
                            }}
                          >
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => onClickUserProfileNav(review)}
                              className="indian-man-smiling-astrologer"
                            >
                              <img
                                style={{
                                  position: "relative",
                                  width: "2.63rem",
                                  height: "2.63rem",
                                }}
                                alt=""
                                src={
                                  review.UserImageURL ?? Icons.ic_default_user
                                }
                              />
                            </div>
                            <div style={{ width: "100%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  alignSelf: "stretch",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() => onClickUserProfileNav(review)}
                                  className="fontSize18Weight400"
                                >
                                  {review.UserName}
                                </div>
                                <div
                                  style={{
                                    fontSize: "0.66rem",
                                    color: "#818181",
                                    left: 0,
                                  }}
                                  className="fontSize18Weight400"
                                >
                                  {moment(review.ReviewDate).format(
                                    "YYYY-MM-DD hh:mm A"
                                  )}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{}}>
                                  <Rating
                                    readonly={true}
                                    initialRating={review.Rating}
                                    emptySymbol={
                                      <span style={{ padding: 2 }}>
                                        <FontAwesomeIcon
                                          icon={regularStar}
                                          style={{ color: Colors.orangeRating }}
                                        />
                                      </span>
                                    }
                                    fullSymbol={
                                      <span style={{ padding: 2 }}>
                                        <FontAwesomeIcon
                                          icon={solidStar}
                                          style={{ color: Colors.orangeRating }}
                                        />
                                      </span>
                                    }
                                  />
                                </div>
                                <div
                                  style={{ marginLeft: "10px", marginTop: 2 }}
                                  className="fontSize18Weight400"
                                >
                                  {review.Rating}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              textAlign: "justify",
                              marginTop: "5px",
                              color: "#818181",
                            }}
                            className="fontSize18Weight400"
                          >
                            {review.Review}
                          </div>
                        </div>
                      </div>

                      {review.hasReplies && review.ReplyReviews && (
                        <div
                          style={{
                            marginLeft: "7rem",
                            padding: "0.75rem 1rem",
                            backgroundColor: "#25252D",
                            borderRadius: "8px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.75rem",
                            }}
                          >
                            <img
                              src={
                                review?.ReplyReviews?.AstrologerImageUrl ??
                                Icons.ic_default_user
                              }
                              alt=""
                              style={{
                                width: "2rem",
                                height: "2rem",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                            <div style={{ width: "100%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  alignSelf: "stretch",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div className="fontSize18Weight400">
                                  {review.ReplyReviews.AstrologerName}
                                </div>
                                <div
                                  style={{
                                    fontSize: "0.66rem",
                                    color: "#818181",
                                    left: 0,
                                  }}
                                  className="fontSize18Weight400"
                                >
                                  {moment(review.ReviewDate).format(
                                    "YYYY-MM-DD hh:mm A"
                                  )}
                                </div>
                              </div>
                              <div
                                style={{ color: "#818181" }}
                                className="fontSize18Weight400"
                              >
                                {review.ReplyReviews.AstrologerRole}
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ color: "#818181", marginTop: "5px" }}
                            className="fontSize18Weight400"
                          >
                            {review.ReplyReviews.Review}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReviewAstrologer;
